export class SignProvider {
  constructor(provider) {
    this.provider = provider;
  }

  getToken() {
    return this.provider.getToken();
  }

  refreshToken() {
    this.provider.refreshToken();
  }
}
